import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { RadioOption } from '@/common/types';
import { API_URL, ICheckWritingTypeDto } from '@/dtos';

export default () => {
  const { isLoading, isSuccess, isError, data, error } = useQuery(['getCheckWritings'], () =>
    api.get<ICheckWritingTypeDto[]>(API_URL.ENUMS_CHECK_WRITINGS)
  );

  const formatedData = useMemo<RadioOption[]>(() => {
    const list = data?.data || [];
    return list.map((listItem) => ({
      label: listItem?.description || '',
      value: listItem?.name || '',
    }));
  }, [data]);

  return {
    data: formatedData || [],
    error,
    isError,
    isLoading,
    isSuccess,
  };
};
